'use strict';

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function round(num, sigfigs) {
  if (sigfigs == null) {
    sigfigs = 2;
  }

  var multiplier = Math.pow(10, sigfigs);
  return Math.round(num * multiplier) / multiplier;
}

function isFunction(fn) {
  var obj = {};
  return fn && obj.toString.call(fn) === '[object Function]';
} // Given a list of numeric properties (or a list of items with a numeric key)
// it returns an object containing stats about the range (min, max, median, etc)
// @param  {Array} list
// @param  {String} [key]
// @param  {Object} [options]
// @param  option {Boolean} forceKey Force the usage of list[n][key] instead of trying to infer list[n].get key
// @return {Object}


function analyze(list, key) {
  var param = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var forceKey = param.forceKey;

  if (list.length === 0) {
    return {};
  }

  var getter = !key ? function (item) {
    return item;
  } : !forceKey && isFunction(list[0].get) ? function (item) {
    return item.get(key);
  } : function (item) {
    return item[key];
  };
  var filteredValues = Array.from(list).map(function (item) {
    return getter(item);
  }).filter(function (val) {
    return Number.isFinite(val);
  });

  if (filteredValues.length === 0) {
    return {};
  }

  filteredValues.sort(function (a, b) {
    return a - b;
  });
  var min = Math.min.apply(Math, _toConsumableArray(filteredValues));
  var max = Math.max.apply(Math, _toConsumableArray(filteredValues));
  var sum = filteredValues.reduce(function (sum, value) {
    return sum + value;
  });
  var median = void 0;

  if (filteredValues.length % 2 === 0) {
    var index = filteredValues.length / 2;
    median = (filteredValues[index - 1] + filteredValues[index]) / 2;
  } else {
    var _index = (filteredValues.length - 1) / 2;

    median = filteredValues[_index];
  }

  return {
    min: min,
    max: max,
    median: median,
    mean: sum / filteredValues.length,
    range: max - min
  };
}

module.exports = {
  round: round,
  analyze: analyze
};